import { Notifications } from "../notifications";
export class BaseButton {
    constructor(data, row) {
        this.buttonId = `row-button-${BaseButton.nextButtonId++}`;
        this.icon = data.icon;
        this.name = data.name;
        this.url = data.url.replace("{id}", row["DT_RowId"]);
        this.confirmMessage = data.confirmMessage;
    }
    onAction(event) {
        event.preventDefault();
        if (this.confirmMessage) {
            Notifications.confirm(this.confirmMessage, () => this.doAction());
        }
        else {
            this.doAction();
        }
    }
    appendTo(parent) {
        parent.append(this.createDomObject());
    }
}
BaseButton.nextButtonId = 1;
